import { Action } from '@ngrx/store';
import { AppointmentRequest } from '../../shared/models/appointment-request.model';
import { type } from '../../util';

export const ActionTypes = {
  ADD_APPOINTMENT_REQUESTS: type('[AppointmentRequests] Add an appointment requests'),
  SELECT_APPOINTMENT_REQUEST: type('[AppointmentRequests] Select an appointment request'),
};

export class AddAppointmentRequests implements Action {
  type = ActionTypes.ADD_APPOINTMENT_REQUESTS;

  constructor(public payload: AppointmentRequest[]) { }
}

export class SelectAppointmentRequest implements Action {
  type = ActionTypes.SELECT_APPOINTMENT_REQUEST;

  constructor(public payload: number) { }
}

export type Actions
  = AddAppointmentRequests
  | SelectAppointmentRequest;



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/home/appointment-requests/appointment-requests.actions.ts